<avd-styling-card-shell [label]="label" [inverseMode]="inverseMode">
    <div token-card-preview class="preview">
        <div
            highchartsChart
            [options]="chartOptions"
            class="preview__chart"
        ></div>
    </div>

    <avd-css-variable-snippet
        token-card-snippets
        [snippet]="cssVariableSnippet"
        language="css"
    ></avd-css-variable-snippet>
</avd-styling-card-shell>
